import { MultilineTextField } from '@cian/multiline-text-field-component';
import * as React from 'react';

import { EAddFeedbackStatus } from '../../../../actions/feedback';
import { SubmitButtonContainer } from '../SubmitButton';
import * as styles from './styles/styles.css';

interface ICommentFormProps {
  formStatus: EAddFeedbackStatus;
  onClick(comment: string): void;
}

interface ICommentFormState {
  comment: string;
  isMounted: boolean;
  isInvalid: boolean;
}

export class CommentForm extends React.PureComponent<ICommentFormProps, ICommentFormState> {
  public state: ICommentFormState = {
    comment: '',
    isInvalid: false,
    isMounted: false,
  };

  public componentDidMount() {
    this.setState({isMounted: true});
  }

  public render() {
    const {comment, isMounted, isInvalid} = this.state;

    return(
      <div className={styles['form_block']}>
        Оставьте отзыв

        {isMounted &&
          <MultilineTextField
            invalid={isInvalid}
            value={comment}
            onValueChange={this.handleChange}
          />
        }

        <SubmitButtonContainer onClick={this.handleClick} />
      </div>
    );
  }

  private handleClick = () => {
    if (!this.state.comment.trim()) {
      this.setState({isInvalid: true});

      return;
    }

    this.props.onClick(this.state.comment);
  }

  private handleChange = (value: string) => {
    this.setState({isInvalid: false, comment: value});
  }
}
